import { BaseModel, attr } from "../../lib/itn-ui-kit/data";
import { hasDynamicValues } from "../../lib/itn-ui-kit/data/decorators";

export default class FollowUpsFormSectionModel extends BaseModel {
  @attr("json") header;
  @hasDynamicValues("follow-ups-form-question", "question") questions;
}
